import { createApp } from 'vue'
import App from './App.vue'

import './assets/scss/app.scss';

const appElement = document.getElementById('app');
const pageType = appElement?.dataset?.pageType || 'default';

const app = createApp(App)

app.provide('pageType', pageType)

app.mount('#app')
